/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetActivecategorymenustate Input Action
 */
export class GetOrderSummaryStateValuesInput implements Msdyn365.IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `modelOpenValue`;
    public getCacheObjectType = () => 'modelOpenValue';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetOrderSummaryStateValuesInput {
    modelOpenValue: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetOrderSummaryStateValuesInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getSelectedQuantityValuesStateAction(
    input: GetOrderSummaryStateValuesInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetOrderSummaryStateValuesInput> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetActivecategorymenustateData[]>('/get/example/id/1', 'get');
    return { modelOpenValue: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetOrderSummaryStateValuesInput>>getSelectedQuantityValuesStateAction,
    // TODO: Give your data action a unique id
    id: 'GetOrderSummaryStateValuesInputStateActionState',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
